import type { Key } from 'react'
import { useState, useRef, useEffect } from 'react'
import IconHasNoClube from 'src/components/Icons/IconHasNoClube'
import IconHasClube from 'src/components/Icons/IconHasClube'

import '../clubeStyles.scss'

const TiersMobile: React.FC<any> = ({ mockProps }) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const containerRef = useRef<HTMLDivElement>(null)

  const scrollToIndex = (index: number) => {
    const container = containerRef.current

    if (container) {
      container.scrollTo({
        left: container.offsetWidth * index,
        behavior: 'smooth',
      })
    }
  }

  const handleScroll = () => {
    const container = containerRef.current

    if (container) {
      const index = Math.round(container.scrollLeft / container.offsetWidth)

      setActiveIndex(index)
    }
  }

  useEffect(() => {
    const container = containerRef.current

    if (!container) {
      return () => {}
    }

    container.addEventListener('scroll', handleScroll)

    return () => container.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className="relative">
      {/* Tabs que controlam o scroll */}
      <div className="flex justify-between gap-x-[8px] mt-4 mb-[30px]">
        {mockProps.map((tier: { name: string }, i: number) => (
          <button
            key={tier.name}
            onClick={() => scrollToIndex(i)}
            className={`py-[12px] w-full rounded-full border font-semibold text-base ${
              i === activeIndex
                ? 'text-[#3643BA] border-[#3643BA]'
                : 'text-black border-[#E1E0DF]'
            }`}
          >
            {tier.name}
          </button>
        ))}
      </div>

      {/* Slider com scroll */}
      <div
        ref={containerRef}
        className="mobileTiers flex overflow-x-auto snap-x snap-mandatory scroll-smooth no-scrollbar"
      >
        {mockProps.map(
          (
            tier: {
              icon: string | undefined
              name: string
              ruleText: any
              benefits: any[]
            },
            i: Key | null | undefined
          ) => (
            <div key={i} className="min-w-full snap-start px-4">
              <div className="bg-white">
                {/* Header */}
                <div className="block mb-4">
                  <img src={tier.icon} alt={tier.name} className="mb-[12px]" />
                  <p className="font-semibold text-[18px] mb-[12px]">
                    {tier.name}
                  </p>
                  <div className="excBnft p-[16px] border border-[#D9DDE1] mb-[28px]">
                    <p
                      className="text-xs"
                      dangerouslySetInnerHTML={{ __html: tier.ruleText }}
                    />
                  </div>
                </div>

                {/* Benefícios */}
                <div className="mt-4 mb-[24px]">
                  {tier.benefits.map(
                    (
                      b: {
                        separator: any
                        label: string
                        enableIcon: boolean
                        description: string
                        statusIcon: boolean
                      },
                      idx: Key | null | undefined
                    ) => (
                      <div key={idx}>
                        <div
                          className={`flex justify-between items-center py-[8px] text-sm ${
                            b.separator
                              ? 'mt-xl pt-xl border-t border-t-[#D9DDE1]'
                              : ''
                          }`}
                        >
                          <span className="text-base leading-[150%] text-[#101010]">
                            {b.label}
                          </span>
                          {b.enableIcon && !b.description ? (
                            b.statusIcon ? (
                              <IconHasClube className="inline-block" />
                            ) : (
                              <IconHasNoClube className="inline-block" />
                            )
                          ) : b.description ? (
                            <p className="text-base leading-[150%] font-semibold">
                              {b.description}
                            </p>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  )
}

export default TiersMobile
